import {
	SP_ORDER_ATTACHMENT_CREATE,
	SP_ORDER_ATTACHMENT_CREATE_SUCCESS,
	SP_ORDER_ATTACHMENT_CREATE_ERROR,
	SP_ORDER_ATTACHMENT_DELETE,
	SP_ORDER_ATTACHMENT_DELETE_SUCCESS,
	SP_ORDER_ATTACHMENT_DELETE_ERROR,
	SP_ORDER_ATTACHMENTS_LIST_FILTERED,
	SP_ORDER_ATTACHMENTS_LIST_FILTERED_SUCCESS,
	SP_ORDER_ATTACHMENTS_LIST_FILTERED_ERROR
} from "../actions/spOrderAttachments";
import SpOrderAttachmentsService from '@/services/spOrderAttachments';

const state = {
	status: ''
};

const getters = {
};

const actions = {
	[SP_ORDER_ATTACHMENT_CREATE]: ({ commit, dispatch }, data) => {
		console.log('data', data);
		let requestData = {
			sp_order_id: data.sp_order_id,
			spOrderAttachments: data.spOrderAttachments,
		}
		return new Promise((resolve, reject) => {
			commit(SP_ORDER_ATTACHMENT_CREATE);
			SpOrderAttachmentsService.create(requestData)
				.then(data => {
					commit(SP_ORDER_ATTACHMENT_CREATE_SUCCESS);
					resolve(data);
				})
				.catch(error => {
					commit(SP_ORDER_ATTACHMENT_CREATE_ERROR, error);
					reject(error);
				});
		});
	},
	[SP_ORDER_ATTACHMENT_DELETE]: ({ commit }, id) => {
		let requestData = {
			id: id,
		}
		return new Promise((resolve, reject) => {
			commit(SP_ORDER_ATTACHMENT_DELETE);
			SpOrderAttachmentsService.delete(requestData)
				.then(responseData => {
					commit(SP_ORDER_ATTACHMENT_DELETE_SUCCESS, responseData);
					resolve(responseData);
				})
				.catch(error => {
					commit(SP_ORDER_ATTACHMENT_DELETE_ERROR, error);
					reject(error);
				});
		});
	},
	[SP_ORDER_ATTACHMENTS_LIST_FILTERED]: ({ commit }, data) => {
		let requestData = {
			size: data.tableProps.itemsPerPage,
			page: data.tableProps.currentPage,
			sort: data.ctx.sortBy,
			desc: data.ctx.sortDesc,
			spOrderIdFilter: data.tableProps.inputFilter.spOrderId
		}
		return new Promise((resolve, reject) => {
			commit(SP_ORDER_ATTACHMENTS_LIST_FILTERED);
			SpOrderAttachmentsService.listFiltered(requestData)
				.then(responseData => {
					commit(SP_ORDER_ATTACHMENTS_LIST_FILTERED_SUCCESS, responseData);
					resolve(responseData);
				})
				.catch(error => {
					commit(SP_ORDER_ATTACHMENTS_LIST_FILTERED_ERROR, error);
					reject(error);
				});
		});
	}
};

const mutations = {
	[SP_ORDER_ATTACHMENT_CREATE]: state => {
		state.status = 'loading';
	},
	[SP_ORDER_ATTACHMENT_CREATE_SUCCESS]: (state, responseData) => {
		state.status = 'success';
	},
	[SP_ORDER_ATTACHMENT_CREATE_ERROR]: state => {
		state.status = 'error';
	},
	[SP_ORDER_ATTACHMENT_DELETE]: state => {
		state.status = 'loading';
	},
	[SP_ORDER_ATTACHMENT_DELETE_SUCCESS]: (state, responseData) => {
		state.status = 'success';
	},
	[SP_ORDER_ATTACHMENT_DELETE_ERROR]: state => {
		state.status = 'error';
	},
	[SP_ORDER_ATTACHMENTS_LIST_FILTERED]: state => {
		state.status = 'loading';
	},
	[SP_ORDER_ATTACHMENTS_LIST_FILTERED_SUCCESS]: (state, responseData) => {
		state.status = 'success';
	},
	[SP_ORDER_ATTACHMENTS_LIST_FILTERED_ERROR]: state => {
		state.status = 'error';
	}
};

export default {
	state,
	getters,
	actions,
	mutations
};